// extracted by mini-css-extract-plugin
export var chartContainer = "whitepaper-module--chartContainer--tSnDa";
export var whitepaperHeader = "whitepaper-module--whitepaperHeader--128U2";
export var brandLogo = "whitepaper-module--brandLogo--33dqR";
export var brandLink = "whitepaper-module--brandLink--3VfpW";
export var brandName = "whitepaper-module--brandName--3L-Xq";